import { render, staticRenderFns } from "./ItemListComplete.vue?vue&type=template&id=e08c85ac&"
import script from "./ItemListComplete.vue?vue&type=script&lang=js&"
export * from "./ItemListComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports